import session from "./session";
import { RootAPI } from "./index";

export default {
  stores() {
    return session().get(RootAPI + "v2/store/search-all" );
  }
};
